<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-base px-6 py-12">
    <a href="/" class="flex items-center gap-2.5 mb-8">
      <img src="@/assets/logo-2.png" alt="Akademi Siber" class="h-10" />
      <span class="text-lg font-extrabold text-white">Akademi<span class="text-brand">Siber</span></span>
    </a>

    <div class="card w-full max-w-md p-8">
      <!-- Success state -->
      <div v-if="message && !isError" class="flex flex-col items-center text-center py-4">
        <i class="fas fa-circle-check text-success text-4xl mb-4"></i>
        <h1 class="text-2xl font-extrabold text-white mb-2">Email Confirmed!</h1>
        <p class="text-ink-muted text-sm mb-6">{{ message }}</p>
        <a href="/login" class="btn-primary w-full justify-center py-3">Go to Login</a>
      </div>

      <!-- Error state -->
      <div v-else-if="message && isError" class="flex flex-col items-center text-center py-4">
        <i class="fas fa-circle-exclamation text-brand text-4xl mb-4"></i>
        <h1 class="text-2xl font-extrabold text-white mb-2">Confirmation Failed</h1>
        <p class="text-ink-muted text-sm mb-6">{{ message }}</p>
        <a href="/resend-confirmation" class="btn-primary w-full justify-center py-3">Resend Confirmation</a>
      </div>

      <!-- Default / loading state -->
      <div v-else class="flex flex-col items-center text-center py-4">
        <h1 class="text-2xl font-extrabold text-white mb-1">Confirm Your Email</h1>
        <p class="text-ink-muted text-sm mb-6">Click the button below to confirm your email address.</p>
        <button @click="confirmEmail" class="btn-primary w-full justify-center py-3" :disabled="isLoading">
          {{ isLoading ? "Processing..." : "Confirm Email" }}
        </button>
      </div>
    </div>

    <p class="text-ink-faint text-xs mt-8">© 2025 SiberLab ID</p>
  </div>
</template>

<script>
// import { useRoute } from "vue-router"; // Import for route parameter access
import toastr from "toastr"; // Importing Toastr
import "toastr/build/toastr.min.css"; // Importing Toastr CSS
import apiClient from "@/axiosConfig"; // Importing Axios configuration

toastr.options = {
  positionClass: "toast-bottom-right",
  closeButton: true,
  progressBar: true,
  timeOut: 5000,
};

export default {
  name: "EmailConfirmation",
  data() {
    return {
      isLoading: false,
      message: "",
      isError: false,
    };
  },
  methods: {
    async confirmEmail() {
      this.isLoading = true;
      this.message = "";
      this.isError = false;

      const token = this.$route.params.token; // Get token from URL

      try {
        // Make GET request to confirm email
        await apiClient.get(`/auth/confirm-email/${token}`);

        // Display success message
        this.message = "Email confirmed successfully!";
        toastr.success(this.message, "Success");

        // Redirect to login page after a delay
        setTimeout(() => {
          this.$router.push("/login");
        }, 3000);
      } catch (error) {
        // Handle errors
        this.isError = true;
        this.message =
          error.response?.data?.message || "Invalid or expired token. Please try again.";
        // toastr.error(this.message, "Error");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
